module.exports = __webpack_public_path__ + "static/media/google.46fcc016.png";